import { useEffect, useState } from "react";

import { Log } from "@ryde/shared";

import { isMapLibreWebGL2Available } from "./maplibre-map.utils";

let hasLoggedWebGL2Skip = false;

/**
 * Whether MapLibre 6 may be constructed in this session. MapLibre cannot draw without WebGL2;
 * constructing it anyway logs GPUInitializationError to console.error and Testim treats that as a
 * failed run. The host mounts a stub instead when this is false.
 */
export const useMapLibreCanRender = (): boolean => {
  const [canRender] = useState(() => isMapLibreWebGL2Available());

  useEffect(() => {
    if (canRender || hasLoggedWebGL2Skip) {
      return;
    }

    hasLoggedWebGL2Skip = true;
    Log.warn(
      "MapLibre skipped: WebGL2 is not available in this browser session",
    );
  }, [canRender]);

  return canRender;
};
